import { z } from '@bonanza-social/toolkit/api';

export const UserSettingsSchema = z.object({
  shouldShowPwa: z.boolean(),
  shouldShowCoinsShopInfo: z.boolean(),
  shouldShowCoinsPlayInfo: z.boolean(),
});
